import { render, staticRenderFns } from "./ViewInsurance.vue?vue&type=template&id=41c5e850&"
import script from "./ViewInsurance.vue?vue&type=script&lang=js&"
export * from "./ViewInsurance.vue?vue&type=script&lang=js&"
import style0 from "./ViewInsurance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports